import { Controller } from "@hotwired/stimulus"
import DataTable from "datatables.net-bs5"

export default class extends Controller {
  connect() {
    this.table = this.element.querySelector(".datatable")
    if (!this.table) return

    this.dataTable = new DataTable(this.table, {
      processing: true,
      serverSide: true,
      ajax: this.table.dataset.source,
      order: [[0, "asc"]],
      columns: [
        { data: "customer_id" },
        { data: "first_name" },
        { data: "last_name" },
        { data: "email", defaultContent: "" },
        { data: "store_id" },
        { data: "create_date", searchable: false },
        {
          data: "status",
          searchable: false,
          render: (status, type) => {
            if (type !== "display") return status

            const color = status === "Active" ? "success" : "secondary"
            return `<span class="badge bg-${color}-gradient">${status}</span>`
          },
        },
      ],
      createdRow: (row) => row.classList.add("align-middle"),
    })
    this.table.style.setProperty("border-collapse", "collapse", "important")
  }

  disconnect() {
    this.dataTable?.destroy()
  }
}
